import Image from '@components/Image'
import { Link } from 'gatsby'
import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import CountUp from 'react-countup'
import { RealEstateDataPageComponentData } from 'types'
import { useInView } from 'react-intersection-observer'
import { ElementHTML } from '@helpers/helper.rendering'
const AboutUs1 = (props: RealEstateDataPageComponentData) => {
  const {
    image_gatsby,
    title,
    paragraph,
    paragraphElement,
    titleElement,
    button,
    items,
    titleColor,
    paragraphHexa,
    opacityValue,
  } = props

  const { ref, inView } = useInView({
    triggerOnce: false, // Cargar solo una vez cuando sea visible
  })

  return (
    <section
      ref={ref}
      className={
        'about-us a pt-5 mt-lg-0 mt-lg-0 position-relative ' +
        (items?.length == 0 ? 'height-flex p-y-config' : '')
      }
    >
      <div
        className="opacity"
        style={{
          opacity:
            opacityValue && opacityValue !== '0'
              ? Number(opacityValue) !== 100
                ? `0.${Number(opacityValue)}`
                : 1
              : 0.6,
        }}
      ></div>
      <Image
        className="w-100 h-100 background-image-absolute no-border "
        objectFit="cover"
        alt="about-us-img"
        image={image_gatsby!!}
      />
      <Container
        fluid
        className="py-lg-5"
      >
        <Row>
          <Col lg={2}>
            <ElementHTML
              children={title!}
              elementType={titleElement || 'p'}
              className="section-name"
              style={{ color: titleColor || '#000' }}
            />
          </Col>
          <Col
            lg={10}
            className="my-5 my-lg-0"
          >
            {paragraph?.split('\n').map((paragraph_, index) => (
              <ElementHTML
                key={index}
                children={paragraph_}
                elementType={paragraphElement || 'h5'}
                style={{ color: paragraphHexa || '#000' }}
                className="sub-section mb-lg-0 mb-3"
              />
            ))}
          </Col>
          <Col
            xs={10}
            lg={{ offset: 2 }}
            className="mt-lg-5"
          >
            <Link
              to={button?.link!}
              className={'btn btn-white ' + (button?.border ? 'border' : '')}
            >
              {button!.value}
            </Link>
          </Col>
          <Col
            lg={{ span: 10, offset: 2 }}
            className={`pt-5 mt-5 ${items?.length === 0 ? 'd-none' : ''}`}
          >
            <Row className="py-lg-5">
              {items?.map((item, index) =>
                index > 1 && index % 2 === 0 ? (
                  <Col
                    lg={6}
                    key={index}
                    className={'pr-lg-4'}
                  >
                    <div className="item">
                      <Row className="no-gutters">
                        <Col
                          xs={6}
                          lg={7}
                          className="text-end"
                        >
                          <h1 className="hyper d-flex justify-content-end">
                            <span className="counter-value one text-white">
                              +
                              {inView ? (
                                <CountUp
                                  start={0}
                                  separator="."
                                  decimals={0}
                                  decimal=","
                                  duration={5}
                                  end={parseFloat(item.value!)}
                                />
                              ) : null}
                            </span>
                          </h1>
                        </Col>
                        <Col
                          xs={6}
                          lg={5}
                          className="px-3 text-white"
                        >
                          <p className="text-white">{item.paragraph}</p>
                        </Col>
                      </Row>
                    </div>
                  </Col>
                ) : (
                  <Col
                    lg={6}
                    key={index}
                  >
                    <div
                      className="item"
                      id="counter"
                    >
                      <Row className="no-gutters">
                        <Col
                          xs={6}
                          lg={7}
                          className="text-end"
                        >
                          <h1 className="hyper text-white d-flex justify-content-end">
                            <span className="counter-value one">
                              +
                              {inView ? (
                                <CountUp
                                  start={0}
                                  separator="."
                                  decimals={0}
                                  decimal=","
                                  // decimals={1}
                                  duration={5}
                                  end={parseFloat(item.value!)}
                                />
                              ) : null}
                            </span>
                          </h1>
                        </Col>
                        <Col className="col-6 col-lg-5 px-3">
                          <p className="text-white">{item.paragraph}</p>
                        </Col>
                      </Row>
                    </div>
                  </Col>
                ),
              )}
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export default AboutUs1
